import { useRef, useState, type FormEvent } from 'react';
import { api, ApiError } from '../lib/api';
import { session } from '../lib/session';
import { ElenaAvatar } from '../components/ElenaAvatar';
import { useLetterIntro, useOpenAnimation } from '../lib/motion';

export function Login({ onDone }: { onDone: () => void }) {
  const [token, setToken] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);
  const main = useRef<HTMLElement>(null);
  const title = useRef<HTMLHeadingElement>(null);
  useOpenAnimation(main);
  useLetterIntro(title);

  const submit = async (e: FormEvent) => {
    e.preventDefault();
    setBusy(true);
    setError(null);
    session.setToken(token.trim());
    try {
      await api.status();
      onDone();
    } catch (err) {
      session.setToken(null);
      setError(
        err instanceof ApiError && err.status === 401
          ? 'Token nije tačan.'
          : 'Server ne odgovara. Proveri da li Elena radi.',
      );
    } finally {
      setBusy(false);
    }
  };

  return (
    <main ref={main} className="login">
      <form className="login-card" onSubmit={submit}>
        <div className="login-avatar">
          <ElenaAvatar mode="idle" />
        </div>
        <h1 ref={title}>Elena</h1>
        <p className="muted">
          Unesi token sa servera (ELENA_TOKEN iz .env). Čuva se samo na ovom uređaju.
        </p>
        <label htmlFor="token" className="sr-only">
          Token
        </label>
        <input
          id="token"
          className="field"
          type="password"
          autoComplete="current-password"
          placeholder="Token"
          value={token}
          onChange={(e) => setToken(e.target.value)}
          autoFocus
        />
        {error && (
          <p className="notice" role="alert">
            {error}
          </p>
        )}
        <button
          type="submit"
          className="btn primary block"
          disabled={busy || token.trim().length < 24}
        >
          {busy ? 'Proveravam…' : 'Uđi'}
        </button>
      </form>
    </main>
  );
}
